// extracted by mini-css-extract-plugin
module.exports = {"sign-out-text":"sign-out-text__30Wb3"};